import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Internships from './pages/Internships';
import Resume from './pages/Resume';
import QA from './pages/QA';
import './App.css';

const App: React.FC = () => {
    return (
        <Router>
            <div className="App">
                <Header />
                <main className="main-content">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/projects/:projectId" element={<Projects />} />
                        <Route path="/internships/:internshipId" element={<Internships />} />
                        <Route path="/resume" element={<Resume />} />
                        <Route path="/qa" element={<QA />} />
                    </Routes>
                </main>
                <Footer />
            </div>
        </Router>
    );
};

export default App;


